module.exports = __webpack_public_path__ + "static/media/ArrowUp.bf5df6ec.svg";